"use client"

import useCognito from "@/components/terra/component/ExternalForm/useCognito"

export default function CognitoForm(props: {
  cognitoScriptID: string
  cognitoFormID: string
}) {
  useCognito({
    cognitoInstance: props.cognitoScriptID,
    formId: props.cognitoFormID,
    followUpUrl: null,
    calendlyId: null,
    calendlyUrl: null,
    onSuccessCallback: () => {},
    formLoaded: false,
  })
  return (
    <div className="cognito-wrapper">
      <div className="cognito"></div>
    </div>
  )
}
